import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Dropdown } from "reactstrap";
import FeatherIcon from "feather-icons-react";

import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import OnlineUsersDropdown from "../CommonForBoth/TopbarDropdown/OnlineUsersDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import SubscriptionBanner from "../Common/SubscriptionBanner";
import PlanLimitIndicator from "../Common/PlanLimitIndicator";
import AnnouncementBanner from "../Common/AnnouncementBanner";
import MenuCountBadge from "../Common/MenuCountBadge";
import GlobalSearch from "../Common/GlobalSearch";

// import images
// Kırpılmış sürüm: asıl dosya 1920x1080 tuvalde çok boşluk taşıyor, kutuya sığınca yazı küçücük kalıyordu.
import logoSvgExpanded from "../../assets/images/tahsilat360_logo2_trim.png";
import logoSvgCollapsed from "../../assets/images/tahsilat360_logo.png";

// API request functions
import { switchBack } from "../../api/requests/auth-requests";
import { fetchPublicCompanyLogo, fetchPublicCompanyFavicon } from "../../api/requests/company-requests";
import { jwtDecode } from "jwt-decode";

// i18n
import { withTranslation } from "react-i18next";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    showRightSidebarAction,
    toggleLeftmenu,
    changeSidebarType,
    changelayoutMode
} from "../../store/actions";
import { createSelector } from 'reselect';

// ✅ useAuth hook
import { useAuth } from "../../hooks/useAuth"; // <-- kendi path’ine göre düzelt
import usePlanFeatures from "../../hooks/usePlanFeatures";
import { BRANDING_UPDATED_EVENT } from "../../utils/branding";
import { mustSelectAccountForCollection } from "../../constants/roles";

const Header = props => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const headerData = createSelector(
        (state) => state.Layout,
        (layout) => ({
            showRightSidebar: layout.showRightSide
        })
    );

    const { showRightSidebar } = useSelector(headerData);

    // Destek kısayolunun rozeti — sol menüdekiyle aynı store alanı okunur (store/supportBadge).
    // Veriyi SidebarContent'teki effect dolduruyor; burada ek istek/state yok, yalnızca aynı
    // değere abone olunur, böylece iki rozet her zaman aynı anda güncellenir.
    const awaitingTicketCount = useSelector(state => state.supportBadge.awaitingReplyCount);
    const myAwaitingReplyCount = useSelector(state => state.supportBadge.awaitingMyReplyCount);
    const subscriptionStatus = useSelector(state => state.subscription.currentStatus);

    const [isImpersonated, setIsImpersonated] = useState(false);
    const [impersonatedUsername, setImpersonatedUsername] = useState("");
    const { onChangeLayoutMode } = props;
    const [socialDrp, setsocialDrp] = useState(false);
    const [isClick, setClick] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    // Dinamik logo state'leri
    const [companyLogo, setCompanyLogo] = useState(null);
    const [companyFavicon, setCompanyFavicon] = useState(null);
    // Yalnız unmount temizliği için: state'e bakan bir cleanup, bağımlılığı her
    // değiştiğinde ekranda DURAN blob'u iptal ediyordu.
    const companyLogoRef = useRef(null);
    const companyFaviconRef = useRef(null);
    const [logoLoading, setLogoLoading] = useState(true);
    const [faviconLoading, setFaviconLoading] = useState(true);
    const [isTablet, setIsTablet] = useState(false);
    const [isNavyHover, setNavyHover] = useState(false);
    const [isOrangeHover, setOrangeHover] = useState(false);
    const [isAnnouncementHover, setAnnouncementHover] = useState(false);

    const currentPath = location.pathname;
    /* Buton yalnızca KENDİ hedef ekranındayken dolu görünür.
       Alt yollar bilinçli olarak dışarıda: /payment/:id ödeme DETAY sayfası,
       /payment-links/:id ise link detay sayfasıdır — ikisine de bu butonlardan
       değil, Ödeme Geçmişi / link listesinden girilir. startsWith kullanıldığında
       detay sayfasına girer girmez buton doluyor, geri çıkınca boşalıyordu. */
    const isPaymentActive = currentPath === '/payment';
    const isPaymentLinkActive = currentPath === '/payment-links';
    const isAnnouncementsActive = currentPath.startsWith('/admin/announcements');

    // ✅ Roller artık useAuth’tan geliyor
    const { roles: userRoles, loadingUser } = useAuth();

    // ✅ SUPER_ADMIN kontrolü
    const isCurrentSuperAdmin = userRoles.includes("ROLE_SUPER_ADMIN");
    const isAccountRoleUser = userRoles.some(r => r.startsWith("ROLE_ACCOUNT_"));
    const paymentWord = isAccountRoleUser ? "Ödeme" : "Tahsilat";
    const showInstantPaymentShortcut = !mustSelectAccountForCollection(userRoles);
    // Cari, bağlı olduğu firmanın paketinde destek talebi yoksa kısayolu görmez (sol menüyle aynı kural).
    const { has: hasFeature, loaded: featuresLoaded } = usePlanFeatures();
    const showSupportShortcut = !isAccountRoleUser || (featuresLoaded && hasFeature("SUPPORT_TICKETS"));

    useEffect(() => {
        const active = localStorage.getItem("impersonationActive") === "true";
        setIsImpersonated(active);

        if (active) {
            setImpersonatedUsername(localStorage.getItem("impersonatedUsername") || "");
        } else {
            setImpersonatedUsername("");
        }
    }, [location.pathname]);

    const handleReturnToAdmin = async () => {
        try {
            const res = await switchBack();

            if (!res.ok) {
                // Geri dönüş başarısız — temizle ve login'e gönder
                localStorage.removeItem("impersonationActive");
                localStorage.removeItem("impersonatedUsername");
                localStorage.removeItem("impersonatorToken");
                navigate("/login");
                return;
            }

            const json = await res.json();
            if (json?.data?.token) {
                try {
                    const decoded = jwtDecode(json.data.token);
                    if (decoded.exp) localStorage.setItem("tokenExp", decoded.exp);
                } catch {}
            }

        } catch {
            localStorage.removeItem("impersonationActive");
            localStorage.removeItem("impersonatedUsername");
            localStorage.removeItem("impersonatorToken");
            navigate("/login");
            return;
        }

        localStorage.removeItem("impersonationActive");
        localStorage.removeItem("impersonatedUsername");
        localStorage.removeItem("impersonatorToken");

        setIsImpersonated(false);
        setImpersonatedUsername("");

        navigate("/dashboard");
        window.location.reload();
    };

    useEffect(() => {
        const checkMobileAndTablet = () => {
            const width = window.innerWidth;
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 992);
        };

        checkMobileAndTablet();
        window.addEventListener('resize', checkMobileAndTablet);

        return () => {
            window.removeEventListener('resize', checkMobileAndTablet);
        };
    }, []);

    // Logo/favicon yükleme. Firma değiştiğinde (süper adminin "kullanıcıya geç"i) ve
    // markalama güncellendiğinde yeniden çağrılır; bu yüzden ÖNCEKİ blob URL'i her
    // seferinde bırakılır, yoksa silinen logo ekranda kalmaya devam ediyordu.
    const loadCompanyAssets = useCallback(async () => {

        // Logo yükleme
        try {
            const logoResponse = await fetchPublicCompanyLogo();

            if (logoResponse.ok && logoResponse.headers.get("Content-Type")?.startsWith("image/")) {
                const logoBlob = await logoResponse.blob();
                const logoUrl = URL.createObjectURL(logoBlob);
                setCompanyLogo(prev => {
                    if (prev) URL.revokeObjectURL(prev);
                    return logoUrl;
                });
            } else {
                // Logo silinmiş: varsayılana dön.
                setCompanyLogo(prev => {
                    if (prev) URL.revokeObjectURL(prev);
                    return null;
                });
            }
        } catch (error) {
            console.log("Company logo yüklenemedi, default logo kullanılacak:", error);
        } finally {
            setLogoLoading(false);
        }

        // Favicon yükleme
        try {
            const faviconResponse = await fetchPublicCompanyFavicon();

            if (faviconResponse.ok && faviconResponse.headers.get("Content-Type")?.startsWith("image/")) {
                const faviconBlob = await faviconResponse.blob();
                const faviconUrl = URL.createObjectURL(faviconBlob);
                setCompanyFavicon(prev => {
                    if (prev) URL.revokeObjectURL(prev);
                    return faviconUrl;
                });
                updateDocumentFavicon(faviconUrl);
            } else {
                setCompanyFavicon(prev => {
                    if (prev) URL.revokeObjectURL(prev);
                    return null;
                });
            }
        } catch (error) {
            console.log("Company favicon yüklenemedi, default favicon kullanılacak:", error);
        } finally {
            setFaviconLoading(false);
        }
    }, []);

    const updateDocumentFavicon = (faviconUrl) => {
        const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
        existingFavicons.forEach(favicon => favicon.remove());

        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.type = 'image/x-icon';
        newFavicon.href = faviconUrl;
        document.head.appendChild(newFavicon);
    };

    // Markalama, oturumdaki firmaya aittir: süper admin "kullanıcıya geç" dediğinde
    // (impersonation bayrağı değişir) yeniden çekilmeli, yoksa panelde önceki firmanın
    // — çoğu zaman platformun — logosu asılı kalıyordu.
    useEffect(() => {
        loadCompanyAssets();
    }, [loadCompanyAssets, isImpersonated, impersonatedUsername]);

    useEffect(() => {
        companyLogoRef.current = companyLogo;
        companyFaviconRef.current = companyFavicon;
    }, [companyLogo, companyFavicon]);

    // Blob'lar yalnız unmount'ta bırakılır.
    useEffect(() => () => {
        if (companyLogoRef.current) URL.revokeObjectURL(companyLogoRef.current);
        if (companyFaviconRef.current) URL.revokeObjectURL(companyFaviconRef.current);
    }, []);

    // Logo/favicon başka bir ekranda yüklendi ya da silindi.
    useEffect(() => {
        const handleBrandingUpdate = () => loadCompanyAssets();
        window.addEventListener(BRANDING_UPDATED_EVENT, handleBrandingUpdate);
        return () => window.removeEventListener(BRANDING_UPDATED_EVENT, handleBrandingUpdate);
    }, [loadCompanyAssets]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isClick) {
                const sidebar = document.querySelector('.vertical-menu');
                const header = document.querySelector('#page-topbar');
                const menuButton = document.querySelector('#vertical-menu-btn');

                if (sidebar && header && menuButton &&
                    !sidebar.contains(event.target) &&
                    !header.contains(event.target)) {

                    if (window.innerWidth < 992) {
                        tToggle();
                    }
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isClick]);

    const getCurrentLogo = () => {
        if (isClick) {
            if (logoLoading) return logoSvgExpanded;
            return companyLogo || logoSvgExpanded;
        } else {
            if (faviconLoading) return logoSvgCollapsed;
            return companyFavicon || logoSvgCollapsed;
        }
    };

    /**
     * Logo ölçüsü PİKSEL ile sınırlanır, yüzdeyle DEĞİL.
     *
     * Masaüstünde eskiden maxWidth/maxHeight '100%' veriliyordu; ancak yüzdeyle
     * verilen max-height, ebeveynin yüksekliği auto olduğunda çözümlenemez ve
     * tarayıcı sınırı yok sayar. .navbar-brand-box'ın yüksekliği tanımlı değil
     * (yalnız genişlik + padding var, satır yüksekliğini .logo'nun line-height'ı
     * verir), dolayısıyla sınır hiç uygulanmıyordu: firma büyük bir görsel
     * yüklediğinde logo doğal boyutunda çizilip 70px'lik header'ı taşıyordu.
     * '120%' ise zaten kutudan TAŞMAYI serbest bırakıyordu.
     *
     * Yükseklikler header (70px) ve daraltılmış kenar çubuğuna göre seçildi;
     * objectFit:'contain' en-boy oranını korur, logo hiçbir ölçüde ezilmez.
     */
    const getLogoStyle = (isLarge = false) => {
        if (isMobile) {
            return {
                maxWidth: isLarge ? '130px' : '40px',
                maxHeight: isLarge ? '36px' : '32px',
                objectFit: 'contain'
            };
        }

        if (isTablet) {
            return {
                maxWidth: isLarge ? '150px' : '50px',
                maxHeight: isLarge ? '50px' : '40px',
                objectFit: 'contain'
            };
        }

        return {
            maxWidth: isLarge ? '190px' : '44px',
            maxHeight: isLarge ? '46px' : '36px',
            objectFit: 'contain'
        };
    };

    const currentLogo = getCurrentLogo();

    function tToggle() {
        var body = document.body;
        setClick(!isClick);
        if (isClick === true) {
            body.classList.remove("sidebar-enable");
            document.body.setAttribute("data-sidebar-size", "sm");
        } else {
            body.classList.add("sidebar-enable");
            document.body.setAttribute("data-sidebar-size", "lg");
        }
    }

    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex align-items-center">
                        <div className="navbar-brand-box" style={{
                            ...(isMobile && {
                                minWidth: '40px',
                                maxWidth: '150px',
                                overflow: 'hidden'
                            })
                        }}>
                            <Link to="/dashboard" className="logo logo-dark">
                                <span className="logo-sm">
                                    <img
                                        src={currentLogo}
                                        alt="Logo"
                                        style={getLogoStyle(false)}
                                        onError={(e) => {
                                            if (isClick && companyLogo && e.target.src === companyLogo) {
                                                e.target.src = logoSvgExpanded;
                                            } else if (!isClick && companyFavicon && e.target.src === companyFavicon) {
                                                e.target.src = logoSvgCollapsed;
                                            }
                                        }}
                                    />
                                </span>
                                <span className="logo-lg">
                                    <img
                                        src={currentLogo}
                                        alt="Logo"
                                        style={getLogoStyle(true)}
                                        onError={(e) => {
                                            if (isClick && companyLogo && e.target.src === companyLogo) {
                                                e.target.src = logoSvgExpanded;
                                            } else if (!isClick && companyFavicon && e.target.src === companyFavicon) {
                                                e.target.src = logoSvgCollapsed;
                                            }
                                        }}
                                    />
                                </span>
                            </Link>

                            <Link to="/dashboard" className="logo logo-light">
                                <span className="logo-sm">
                                    <img
                                        src={currentLogo}
                                        alt=""
                                        height={isMobile ? "28" : (isClick ? "32" : "28")}
                                        style={{
                                            ...getLogoStyle(false),
                                            marginLeft: (!isClick && !isMobile) ? "-8px" : "0"
                                        }}
                                        onError={(e) => {
                                            if (isClick && companyLogo && e.target.src === companyLogo) {
                                                e.target.src = logoSvgExpanded;
                                            } else if (!isClick && companyFavicon && e.target.src === companyFavicon) {
                                                e.target.src = logoSvgCollapsed;
                                            }
                                        }}
                                    />
                                </span>
                                <span className="logo-lg">
                                    <img
                                        src={currentLogo}
                                        alt=""
                                        height={isMobile ? "28" : "32"}
                                        style={getLogoStyle(true)}
                                        onError={(e) => {
                                            if (isClick && companyLogo && e.target.src === companyLogo) {
                                                e.target.src = logoSvgExpanded;
                                            } else if (!isClick && companyFavicon && e.target.src === companyFavicon) {
                                                e.target.src = logoSvgCollapsed;
                                            }
                                        }}
                                    />
                                </span>
                            </Link>
                        </div>

                        <button
                            onClick={() => tToggle()}
                            type="button"
                            className="btn btn-sm px-3 font-size-16 header-item align-self-center"
                            id="vertical-menu-btn"
                            style={{
                                minWidth: isMobile ? '40px' : 'auto',
                                padding: isMobile ? '8px' : '8px 12px'
                            }}
                        >
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                    </div>

                    {/* Duyuru şeridi header'ın içinde, sola yaslı. Akışta durduğu
                        için sidebar daraldığında (condensed) kendiliğinden kayar;
                        sabit konumlandırma iki sidebar durumu için ayrı ayrı
                        hesap gerektirirdi. */}
                    <AnnouncementBanner />

                    <div className="d-flex align-items-center ps-3" style={{ gap: isMobile ? '4px' : '8px' }}>
                        <Dropdown
                            className="d-none d-lg-inline-block ms-1"
                            isOpen={socialDrp}
                            toggle={() => setsocialDrp(!socialDrp)}
                        />

                        {showInstantPaymentShortcut && (
                        <div className="d-none d-lg-inline-block ms-1">
                            <Link
                                to="/payment?type=normal"
                                className="btn btn-sm rounded-3"
                                style={{
                                    backgroundColor: isPaymentActive ? '#0A316E' : (isNavyHover ? '#0A316E' : 'transparent'),
                                    borderColor: '#0A316E',
                                    color: isPaymentActive || isNavyHover ? 'white' : '#0A316E',
                                    fontWeight: 500,
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={() => setNavyHover(true)}
                                onMouseLeave={() => setNavyHover(false)}
                            >
                                {`Anlık ${paymentWord}`}
                            </Link>
                        </div>
                        )}

                        <div className="d-none d-lg-inline-block ms-1">
                            <Link
                                to="/payment-links"
                                className="btn btn-sm rounded-3"
                                style={{
                                    backgroundColor: isPaymentLinkActive ? '#FFA500' : (isOrangeHover ? '#FFA500' : 'transparent'),
                                    borderColor: '#FFA500',
                                    color: isPaymentLinkActive || isOrangeHover ? 'white' : '#FFA500',
                                    fontWeight: 500,
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={() => setOrangeHover(true)}
                                onMouseLeave={() => setOrangeHover(false)}
                            >
                                {`Link ile ${paymentWord}`}
                            </Link>
                        </div>

                        {/* Duyuru yönetimi kısayolu — yalnız süper admin.
                            Asıl yetki sınırı backend'de (AnnouncementRestController
                            @PreAuthorize); bu sadece menü gizleme. */}
                        {isCurrentSuperAdmin && (
                            <div className="d-none d-lg-inline-block ms-1">
                                <Link
                                    to="/admin/announcements"
                                    className="btn btn-sm rounded-3"
                                    style={{
                                        backgroundColor: isAnnouncementsActive || isAnnouncementHover ? '#0A316E' : 'transparent',
                                        borderColor: '#0A316E',
                                        color: isAnnouncementsActive || isAnnouncementHover ? 'white' : '#0A316E',
                                        fontWeight: 500,
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={() => setAnnouncementHover(true)}
                                    onMouseLeave={() => setAnnouncementHover(false)}
                                >
                                    {/* Sol menüden kaldırılan duyuru girişinin hoparlör ikonu buraya taşındı. */}
                                    <FeatherIcon icon="volume-2" size={14} className="me-1" style={{ verticalAlign: '-2px' }} />
                                    Duyurular
                                </Link>
                            </div>
                        )}

                        <SubscriptionBanner />

                        <GlobalSearch />

                        {showSupportShortcut && (
                        <div className="dropdown d-inline-block">
                            {/* Süper admin destek yönetimine, diğer kullanıcılar kendi taleplerine gider. */}
                            <Link
                                to={isCurrentSuperAdmin ? "/admin/tickets" : "/support"}
                                className="btn header-item noti-icon position-relative d-inline-flex align-items-center justify-content-center"
                                title={isCurrentSuperAdmin ? "Destek Yönetimi" : "Destek Taleplerim"}
                            >
                                <FeatherIcon icon="headphones" className="icon-lg" />
                                {/* Sol menüdeki rozetin aynısı: süper adminde sayı, diğer rollerde nokta. */}
                                {isCurrentSuperAdmin ? (
                                    <MenuCountBadge
                                        count={awaitingTicketCount}
                                        title="Yanıt bekleyen destek talebi"
                                        overlay
                                    />
                                ) : (
                                    <MenuCountBadge
                                        count={myAwaitingReplyCount}
                                        title="Talebinize yanıt geldi"
                                        dot
                                        overlay
                                    />
                                )}
                            </Link>
                        </div>
                        )}

                        {isCurrentSuperAdmin && <OnlineUsersDropdown />}

                        {/* Paket limiti uyarısı bildirim zilinin solunda; uyarılacak limit yoksa çizilmez. */}
                        {!isCurrentSuperAdmin && subscriptionStatus && (
                            <PlanLimitIndicator status={subscriptionStatus} />
                        )}

                        <NotificationDropdown />

                        {/* ✅ Impersonation aktif ama kullanıcı zaten SUPER_ADMIN değilse göster */}
                        {isImpersonated && !isCurrentSuperAdmin && (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-3 ms-1 d-none d-md-inline-flex align-items-center"
                                    style={{
                                        backgroundColor: '#E07A7A',
                                        borderColor: '#E07A7A',
                                        color: 'white',
                                        fontWeight: 500
                                    }}
                                    onClick={handleReturnToAdmin}
                                    title="Süper admin oturumuna dön"
                                >
                                    <i className="bx bx-user-check me-1" />
                                    Admin'e dön
                                    {impersonatedUsername && (
                                        <span className="ms-2" style={{ fontSize: '0.8rem', opacity: 0.9 }}>
                                            ({impersonatedUsername})
                                        </span>
                                    )}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle ms-1 d-inline-flex d-md-none align-items-center justify-content-center"
                                    style={{
                                        backgroundColor: '#E07A7A',
                                        borderColor: '#E07A7A',
                                        color: 'white',
                                        width: '32px',
                                        height: '32px'
                                    }}
                                    onClick={handleReturnToAdmin}
                                    title="Admin'e dön"
                                >
                                    <i className="bx bx-user-check" />
                                </button>
                            </>
                        )}

                        <div style={{ minWidth: isMobile ? '40px' : 'auto' }}>
                            <ProfileMenu />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

Header.propTypes = {
    changeSidebarType: PropTypes.func,
    leftMenu: PropTypes.any,
    showRightSidebar: PropTypes.any,
    showRightSidebarAction: PropTypes.func,
    t: PropTypes.any,
    toggleLeftmenu: PropTypes.func,
    changelayoutMode: PropTypes.func,
    layoutMode: PropTypes.any,
};

const mapStatetoProps = state => {
    const {
        layoutType,
        showRightSidebar,
        leftMenu,
        layoutMode
    } = state.Layout;
    return { layoutType, showRightSidebar, leftMenu, layoutMode };
};

export default connect(mapStatetoProps, {
    showRightSidebarAction,
    changelayoutMode,
    toggleLeftmenu,
    changeSidebarType,
})(withTranslation()(Header));